<div *transloco="let t" class="flex h-screen flex-col items-center justify-center gap-6 bg-blue-50 px-4">
  <pxc-loader [status]="Status.ERROR" [useLogo]="true" />

  <h1 class="text-center" tuiTitle="l">
    {{ t('Authentification indisponible') }}
  </h1>
  @let error = error$ | async;
  <p class="text-balance text-center">
    @switch (+error) {
      @case (HttpCustomErrorCode.EMAIL_NOT_FOUND) {
        {{ t('Votre établissement ne vous a pas invité à utiliser Pixacare.') }}
      }
      @default {
        {{ t('Veuillez nous excuser pour la gêne occasionnée.') }}
      }
    }
  </p>
  <button appearance="primary" size="l" tuiButton type="button" (click)="login()">
    {{ t('Revenir à la page de connexion') }}
  </button>
</div>
